import axios from "axios";
import { showToast } from "vant";
import router from "../router";
import Qs from "qs";
import i18n from "../language";
import { getServiceType } from "./theme";

const Instance = axios.create({ baseURL: process.env.VUE_APP_BASE_URL });
// const Instance = axios.create({ baseURL: "/" });
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
const Instance_old = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_OLD,
});
let pending = [];
const CancelToken = axios.CancelToken;
// const getTimestamp = () => new Date().getTime(); //时间戳
const removePending = (config) => {
  // 发起请求的时候，去掉同样的请求
  for (let p in pending) {
    if (
      pending[p].u ===
      config.url + JSON.stringify(config.data) + "&" + config.method
    ) {
      pending[p].f();
      pending.splice(p, 1);
    }
  }
};

//请求拦截器
Instance.interceptors.request.use(
  (config) => {
    config.headers.glp_user_token = localStorage.getItem("token");
    const serviceType = getServiceType();
    if (config.method === 'get') {
      config.params = { ...config.params, serviceType };
    } else {
      // 如果数据为空，则初始化为一个对象
      if (!config.data) {
        config.data = { serviceType };
      }
      // 处理数组的情况：遍历每一项并添加 serviceType
      else if (Array.isArray(config.data)) {
        config.data = config.data.map(item => ({
          ...item,
          serviceType
        }));
      }
      // 处理字符串 (例如已经序列化的字符串)
      else if (typeof config.data === 'string') {
        // 注意：这种简单的字符串拼接对于复杂对象字符串可能不严谨，建议在调用层尽量传对象
        config.data = config.data + '&serviceType=' + encodeURIComponent(serviceType);
      }
      // 处理 FormData
      else if (config.data instanceof FormData) {
        config.data.append('serviceType', serviceType);
      }
      // 处理普通对象
      else {
        config.data = { ...config.data, serviceType };
      }
    }
    removePending(config);
    config.cancelToken = new CancelToken((c) => {
      pending.push({
        u: config.url + JSON.stringify(config.data) + "&" + config.method,
        f: c,
      });
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Instance.defaults.timeout = 60000;
let flag = true;
//响应拦截器即异常处理
Instance.interceptors.response.use(
  (response) => {
    // console.log("response :", response);

    removePending(response.config);
    if (response.status === 209) {
      // Toast(`接口服务超出限制，请联系商务`);
      return;
    }
    if (response.data.httpCode === 200) {
      return response.data.result;
    } else if (/^20*/.test(response.data.httpCode)) {
      return response.data;
    } else if (response.data.httpCode === 401) {
      console.log("登录失效", 1);
      if (flag) {
        flag = false;
        let backPath =
          (router.currentRoute &&
            router.currentRoute.value &&
            router.currentRoute.value.path) ||
          "";
        let query =
          router.currentRoute &&
          router.currentRoute.value &&
          router.currentRoute.value.query;
        router.push({ path: "/login", query: { backPath, ...query } });
        // 登录失效，请重新登录
        showToast(i18n.global.t("text100153"));
        // showLogin();
      }
    } else {
      if (response.data.message || response.data.msg) {
        // Toast(`${response.data.message || response.data.msg}`);
        showToast(`${response.data.message || response.data.msg}`);
      } else if (response.data.httpCode === 500) {
        showToast(`服务端出错了`);
      } else {
        return response.data;
      }
    }
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "错误请求";
          break;
        case 401:
          if (flag) {
            console.log("登录失效", 2, router);
            console.log(router.currentRoute.value.fullPath);
            let backPath =
              (router.currentRoute &&
                router.currentRoute.value &&
                router.currentRoute.value.path) ||
              "";
            let query =
              router.currentRoute &&
              router.currentRoute.value &&
              router.currentRoute.value.query;
            router.push({ path: "/login", query: { backPath, ...query } });
            showToast(i18n.global.t("text100153"));
            flag = false;
            // showLogin();
          }
          return;
        // break
        case 404:
          err.message = "请求错误,未找到该资源,404.";
          break;
        case 500:
          err.message = "服务器端出错,错误代码500";
          break;
        default:
          err.message = `网络错误，请稍后再试，${err.response.status}`;
      }
      if (err.message) showToast(err.message);
    } else {
      if (err.code === "ECONNABORTED" || err.message === "Network Error") {
        // 请求超时
        // Toast("请求超时");
      } else {
        err.message = "取消请求";
        // message.error(err.message)
      }
    }
    return Promise.reject(err);
  }
);

//请求拦截器
Instance_old.interceptors.request.use(
  (config) => {
    // config.headers.glp_user_token = localStorage.getItem("token");
    //发起请求时，取消掉当前正在进行的相同请求
    removePending(config);
    config.cancelToken = new CancelToken((c) => {
      pending.push({
        u: config.url + JSON.stringify(config.data) + "&" + config.method,
        f: c,
      });
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Instance_old.defaults.timeout = 60000;
let flag_old = true;
//响应拦截器即异常处理
Instance_old.interceptors.response.use(
  (response) => {
    // console.log("response :", response);

    removePending(response.config);
    if (response.status === 209) {
      // Toast(`接口服务超出限制，请联系商务`);
      return;
    }
    if (response.data.head.code == "000000") {
      return response.data;
    } else {
      showToast(
        (response.data.head && response.data.head.message) || "系统错误"
      );
      return;
    }
  },
  (err) => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "错误请求";
          break;
        case 401:
          if (flag_old) {
            flag_old = false;
            // showLogin();
          }
          return;
        // break
        case 404:
          err.message = "请求错误,未找到该资源,404.";
          break;
        case 500:
          err.message = "服务器端出错,错误代码500";
          break;
        default:
          err.message = `网络错误，请稍后再试，${err.response.status}`;
      }
      // if (err.message) Toast(err.message);
    } else {
      if (err.code === "ECONNABORTED" || err.message === "Network Error") {
        // 请求超时
        // Toast("请求超时");
      } else {
        err.message = "取消请求";
        // message.error(err.message)
      }
    }
    return Promise.reject(err);
  }
);

export default {
  //get请求
  get(url, param) {
    return Instance({
      method: "get",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
      url,
      params: param,
    });
  },
  //post请求
  post(url, param) {
    return Instance({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
      url,
      data: Qs.stringify(param),
    });
  },
  //post请求
  postOld(url, param) {
    return Instance_old({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
      url,
      data: Qs.stringify(param),
    });
  },
  postForm(url, param) {
    return Instance({
      method: "POST",
      url,
      data: param,
      headers: {
        "Content-Type": "multipart/form-data",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
      withCredentials: true,
    });
  },
  postQs(url, param) {
    return Instance({
      method: "POST",
      url,
      params: param,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
    });
  },
  postFormData(url, param, pageInfo) {
    return Instance({
      method: "POST",
      url,
      data: param,
      params: pageInfo,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
    });
  },
  postFile(url, param) {
    return Instance({
      method: "GET",
      url,
      params: param,
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "GLP-LANGUAGE": localStorage.getItem("i18n") || "zh",
      },
    });
  },
  postGame(url, param) {
    return Instance({
      method: "POST",
      url,
      data: param,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    });
  },
};
